import type { BaseFormElement } from '@/formbuilder/formBuilder.constants';

export type FlexLayoutSplitterProps = {
  component: 'FlexLayoutSplitter';
  name: string;
  /** Share of the parent container for the pane above the splitter (0–1, exclusive). */
  upperPaneFlex?: number;
  /** Persists the upper pane's share of the parent after the user finishes dragging. */
  onUpperPaneFlexChange?: (flex: number) => void;
} & BaseFormElement;

export const FlexLayoutSplitter = ({ testId }: FlexLayoutSplitterProps) => {
  return <></>;
};
